import { client } from '@/client';
import { HighlightedCourse } from '@/client/courses';
import {
  COURSES_LIST_CACHE_TIME,
  HIGHLIGHTED_COURSES_QUERY_KEY,
} from '@/hooks/query/courses.query-keys';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';

export const useHighlightedCourses = (
  accountId?: string,
  options: UseQueryOptions = {},
): UseQueryResult<HighlightedCourse[]> & {
  highlightedCourses: HighlightedCourse[] | undefined;
} => {
  const { data, ...rest } = useQuery(
    [HIGHLIGHTED_COURSES_QUERY_KEY, accountId],
    () => client.courses.getHighlightedCourses(accountId as string),
    {
      enabled: !!accountId,
      retry: false,
      cacheTime: COURSES_LIST_CACHE_TIME,
      ...(options as any),
    },
  );

  return {
    highlightedCourses: data,
    ...(rest as UseQueryResult<HighlightedCourse[]>),
  };
};
